import { ReactNode } from "react";
import { Box, Container, Image, Flex, Text } from "@chakra-ui/react";
import useGlobalStore from "app/store";
import { useTranslation } from "react-i18next";

type AppContainerProps = {
  children: ReactNode;
};

export default function AppContainer({ children }: AppContainerProps) {
  const { t } = useTranslation();
  const logoUrl = useGlobalStore((state) => state.customization?.logoUrl);

  return (
    <Container
      maxW={{ base: "100%", md: "90%", lg: "80%" }}
      px={{ base: 4, md: 6 }}
      py={{ base: 4, md: 6 }}
      bg="white"
    >
      {/* Top Right: Partner logo */}
      <Flex justifyContent="flex-end" alignItems="center" mb={{ base: 4, md: 6 }}>
        <Flex
          alignItems="center"
          gap={{ base: 1, md: 2 }}
          flexDirection={{ base: "column", md: "row" }}
        >
          <Text fontSize={{ base: "3xs", md: "xs" }} color="gray.600" whiteSpace="nowrap">
            {t("inPartnershipWith")}
          </Text>
          <Image
            src="https://getoze.com/app/uploads/2022/05/logo.svg"
            alt="Oze"
            height={{ base: "20px", md: "18px" }}
          />
        </Flex>
      </Flex>

      {/* Left: Brand logo */}
      <Box
        mb={{ base: 4, md: 6 }}
        position={{ base: "absolute", md: "static" }}
        top={{ base: "6", md: "auto" }}
        left={{ base: "4", md: "auto" }}
        zIndex={{ base: "10", md: "auto" }}
      >
        {logoUrl && (
          <Image
            src={logoUrl}
            alt="Logo"
            height={{ base: "45px", md: "32px" }}
            maxW={{ base: "220px", md: "none" }}
          />
        )}
      </Box>

      {/* Main content */}
      <Box px={{ base: 0, md: 2 }}>{children}</Box>
    </Container>
  );
}
